import React, { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import "../Layout/menubaar.css";
// import dashboard from "../../image/dashboard-plus.png";
import FeatherIcon from "feather-icons-react";
import { usePopup } from "../Common/PopupContext";
import DeleteAccount from "../Empolyers/DeleteAccount";
import { getUserData } from "../../helpers/utils";
import CourseIcon from "../../img/course_icon.png";
import api from "../../Api";
const Menubar = () => {
  const toggleSubMenu = (e) => {
    let arrowParent = e.currentTarget.parentElement; // Selecting parent element of arrow
    arrowParent.classList.toggle("showMenu");
  };
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return (
    <>
      <div className={`sidebar ${sidebarOpen ? "open" : "close"}`}>
        <div className="cross-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-left" color="#fff" size={24} />
        </div>
        <div className="plus-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-right" color="#fff" size={24} />
        </div>
        <div className="main-continor">
          <ul className="nav-links">
            <li className="hover:text-white">
              <a href="/admin">
                <FeatherIcon
                  icon="grid"
                  size={20}
                  color="#003366"
                  className="hover:text-white"
                />
                <span className="link_name">Dashboard</span>
              </a>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/admin">
                    Dashboard
                  </a>
                </li>
              </ul>
            </li>

            <li>
              <a href="">
                <FeatherIcon
                  icon="users"
                  size={20}
                  color="#003366"
                  className="hover:text-white"
                />
                <span className="link_name">Manage Users</span>
              </a>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Manage Users
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="">
                <svg
                  className="hover:fill-white W-[20px]"
                  fill="#003366"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                >
                  <path d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z" />
                </svg>
                <span className="link_name"> Manage Jobs</span>
              </a>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Manage Jobs
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="">
                <svg
                  fill="#003366"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H176zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z" />
                </svg>
                <span className="link_name"> Manage Applications</span>
              </a>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Manage Applications
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="">
                <svg
                  fill="#003366"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z" />
                </svg>

                <span className="link_name">Message</span>
              </a>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Message
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="">
                <svg
                  fill="#003366"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
                </svg>
                <span className="link_name"> Profile Settings</span>
              </a>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Profile Settings
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="">
                <svg
                  fill="#003366"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z" />
                </svg>
                <span className="link_name"> Tickets</span>
              </a>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Tickets
                  </a>
                </li>
              </ul>
            </li>

            {/* Other menu items */}
          </ul>
        </div>
      </div>
    </>
  );
};
const Employers = () => {
  const [activeLink, setActiveLink] = useState("");
  const location = useLocation(); // React Router's hook to get the current location
  const User = getUserData();
  useEffect(() => {
    const pathname = location.pathname;

    // Normalize the pathname
    const normalizedPathname = pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

    // Set the active link based on the current pathname
    setActiveLink(normalizedPathname);
  }, [location.pathname]); // Run this effect when location.pathname changes

  const handleLinkClick = (linkName) => {
    // Normalization is handled in the effect
    const normalizedLinkName = linkName.endsWith("/")
      ? linkName.slice(0, -1)
      : linkName;

    setActiveLink(normalizedLinkName);
  };

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  /* ======= For Popup ====== */
  const { openPopup } = usePopup();
  // const [popupComponent, setPopupComponent] = useState(null);

  const handleClosePopup = (message) => {
    //console.log(message);
    //setPopupComponent(null);
    openPopup();
  };

  const DeleteAccountAction = () => {
    const popup = (
      <DeleteAccount onClose={() => handleClosePopup("Popup closed")} />
    );
    //setPopupComponent(popup);
    openPopup(popup);
  };
  /* ======= Ends Popup ====== */
  const [SettingSubMenuOpen, setSettingSubMenuOpen] = useState();
  const togglesettingSubMenu = () => {
    setSettingSubMenuOpen(!SettingSubMenuOpen);
  };
  return (
    <>
      <div className={`sidebar ${sidebarOpen ? "open" : "close"}`}>
        <div className="cross-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-left" color="#fff" size={24} />
        </div>
        <div className="plus-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-right" color="#fff" size={24} />
        </div>
        <div className="main-continor">
          <ul className="nav-links">
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard"
                onClick={() => handleLinkClick("/dashboard")}
              >
                <svg
                  width="34"
                  height="40"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.1225 19.1247H6.63287C5.90555 19.1288 5.20941 19.4206 4.69657 19.9364C4.18373 20.4521 3.89586 21.1499 3.89587 21.8773V27.3668C3.89587 28.0927 4.18424 28.7889 4.69752 29.3022C5.21081 29.8155 5.90698 30.1038 6.63287 30.1038H12.1225C12.8497 30.1039 13.5473 29.8159 14.0628 29.3031C14.5784 28.7902 14.8699 28.094 14.8736 27.3668V21.8773C14.8736 21.1476 14.5838 20.4478 14.0678 19.9319C13.5519 19.4159 12.8521 19.1261 12.1225 19.1261M12.1225 3.89551H6.63287C6.27345 3.89551 5.91754 3.9663 5.58547 4.10385C5.2534 4.2414 4.95168 4.443 4.69752 4.69716C4.44337 4.95131 4.24176 5.25304 4.10422 5.5851C3.96667 5.91717 3.89587 6.27308 3.89587 6.63251V12.1221C3.89586 12.8493 4.18377 13.5469 4.69666 14.0625C5.20954 14.578 5.90568 14.8695 6.63287 14.8733H12.1225C12.8521 14.8733 13.5519 14.5834 14.0678 14.0675C14.5838 13.5515 14.8736 12.8517 14.8736 12.1221V6.63251C14.8699 5.90531 14.5784 5.20917 14.0628 4.69629C13.5473 4.18341 12.8497 3.8955 12.1225 3.89551ZM27.3672 3.89551H21.8776C21.1504 3.8955 20.4528 4.18341 19.9372 4.69629C19.4217 5.20917 19.1302 5.90531 19.1265 6.63251V12.1221C19.1268 12.8516 19.4168 13.5512 19.9327 14.067C20.4485 14.5829 21.1481 14.8729 21.8776 14.8733H27.3672C28.0944 14.8695 28.7905 14.578 29.3034 14.0625C29.8163 13.5469 30.1042 12.8493 30.1042 12.1221V6.63251C30.1042 5.90661 29.8158 5.21044 29.3026 4.69716C28.7893 4.18387 28.0931 3.89551 27.3672 3.89551Z"
                    stroke="#003366"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="path-icon"
                  />
                  <path
                    d="M24.6047 19.5742V29.6552M19.5741 24.6261H29.6551"
                    // stroke="#003366"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    className="path-icon"
                  />
                </svg>
                <span className="link_name">Dashboard</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard">
                    Dashboard
                  </a>
                </li>
              </ul>
            </li>
            {User?.role == "employer" ? (
              <li
                className={`dashboard-menu-icon ${
                  activeLink === "/dashboard/manage-user" ? "nav-active" : ""
                }`}
              >
                <Link
                  to="/dashboard/manage-user"
                  onClick={() => handleLinkClick("/dashboard/manage-user")}
                >
                  <svg
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-label="Manage Users Icon"
                  >
                    <path
                      d="M21.25 15.5836V18.4164M24.0836 15.5836H9.91644M22.6664 9.91644H11.3336V5.66644C11.3336 5.29078 11.4828 4.9305 11.7484 4.66487C12.0141 4.39923 12.3743 4.25 12.75 4.25H21.25C21.6257 4.25 21.9859 4.39923 22.2516 4.66487C22.5172 4.9305 22.6664 5.29078 22.6664 5.66644V9.91644Z"
                      stroke="#003366"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M29.75 28.3331V11.3331C29.75 10.9574 29.6008 10.5971 29.3352 10.3313C29.0696 10.0656 28.7093 9.9162 28.3336 9.91602H5.66644C4.88444 9.91602 4.25 10.5505 4.25 11.3331V28.3331C4.25 29.1151 4.88444 29.7496 5.66644 29.7496H28.3336C29.1156 29.7496 29.75 29.1151 29.75 28.3331Z"
                      stroke="#003366"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="link_name">Manage Users</span>
                </Link>
                <ul className="sub-menu blank">
                  <li>
                    <Link className="link_name" to="/dashboard/manage-user">
                      Manage Users
                    </Link>
                  </li>
                </ul>
              </li>
            ) : (
              ""
            )}
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/manage-jobs" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/manage-jobs"
                onClick={() => handleLinkClick("/dashboard/manage-jobs")}
              >
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="#003366"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34 27.625V25.5H31.7677C31.6298 24.8351 31.3658 24.2029 30.9899 23.6374L32.5731 22.0543L31.0707 20.5519L29.4876 22.1351C28.9221 21.7592 28.2899 21.4952 27.625 21.3573V19.125H25.5V21.3573C24.8351 21.4952 24.2029 21.7592 23.6374 22.1351L22.0543 20.5519L20.5519 22.0543L22.1351 23.6374C21.7592 24.2029 21.4952 24.8351 21.3573 25.5H19.125V27.625H21.3573C21.4954 28.3018 21.7653 28.9308 22.1351 29.4876L20.5519 31.0707L22.0543 32.5731L23.6374 30.9899C24.2029 31.3658 24.8351 31.6298 25.5 31.7677V34H27.625V31.7677C28.2899 31.6298 28.9221 31.3658 29.4876 30.9899L31.0707 32.5731L32.5731 31.0707L30.9899 29.4876C31.3658 28.9221 31.6298 28.2899 31.7677 27.625H34ZM26.5625 29.75C24.8051 29.75 23.375 28.3199 23.375 26.5625C23.375 24.8051 24.8051 23.375 26.5625 23.375C28.3199 23.375 29.75 24.8051 29.75 26.5625C29.75 28.3199 28.3199 29.75 26.5625 29.75ZM21.25 18.0625H12.75C12.1864 18.0625 11.6459 17.8386 11.2474 17.4401C10.8489 17.0416 10.625 16.5011 10.625 15.9375V4.25C10.625 3.68641 10.8489 3.14591 11.2474 2.7474C11.6459 2.34888 12.1864 2.125 12.75 2.125H21.25C21.8136 2.125 22.3541 2.34888 22.7526 2.7474C23.1511 3.14591 23.375 3.68641 23.375 4.25V15.9375C23.375 16.5011 23.1511 17.0416 22.7526 17.4401C22.3541 17.8386 21.8136 18.0625 21.25 18.0625ZM12.75 15.9375H21.25V4.25H12.75V15.9375Z"
                    // fill="#003366"
                    className="path-icon"
                  />
                  <path
                    d="M18.0625 22.3125H8.5C7.93641 22.3125 7.39591 22.0886 6.9974 21.6901C6.59888 21.2916 6.375 20.7511 6.375 20.1875V7.4375H8.5V20.1875H18.0625V22.3125Z"
                    // fill="#003366"
                    className="path-icon"
                  />
                  <path
                    d="M13.8125 26.5625H4.25C3.07806 26.5625 2.125 25.6094 2.125 24.4375V11.6875H4.25V24.4375H13.8125V26.5625Z"
                    // fill="#003366"
                    className="path-icon"
                  />
                </svg>

                <span className="link_name"> Manage Jobs</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard/jobs">
                    Manage Jobs
                  </a>
                </li>
              </ul>
            </li>
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/job-applications" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/job-applications"
                onClick={() => handleLinkClick("/dashboard/job-applications")}
              >
                <svg
                  fill="#003366"
                  width="34"
                  height="34"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H176zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z" />
                </svg>
                <span className="link_name"> Manage Applications</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Manage Applications
                  </a>
                </li>
              </ul>
            </li>

            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/messages" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/messages"
                onClick={() => handleLinkClick("/dashboard/messages")}
              >
                <svg
                  className="icon"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_69_22)">
                    <path
                      d="M3.92308 5.23047C1.75754 5.23047 0 6.98801 0 9.15355V24.8459C0 27.0114 1.75754 28.7689 3.92308 28.7689H30.0769C32.2425 28.7689 34 27.0114 34 24.8459V9.15355C34 6.98801 32.2425 5.23047 30.0769 5.23047H3.92308ZM3.92308 7.84585H30.0769C30.7975 7.84585 31.3846 8.43301 31.3846 9.15355V9.80739L17 17.5725L2.61538 9.80739V9.15355C2.61538 8.43301 3.20254 7.84585 3.92308 7.84585ZM2.61538 10.1749L11.1559 16.8362L2.77885 25.4186L12.9958 18.1439L17 20.7188L21.0055 18.1439L31.2212 25.4186L22.8441 16.8362L31.3846 10.1749V24.8459C31.3774 25.0472 31.3213 25.2438 31.2212 25.4186C31.0054 25.8436 30.5856 26.1535 30.0769 26.1535H3.92308C3.41438 26.1535 2.99462 25.8449 2.77885 25.4186C2.67892 25.2442 2.62283 25.0468 2.61538 24.8459V10.1749Z"
                      className="icon-path"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_69_22">
                      <rect width="34" height="34" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span className="link_name"> Messages</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Messages
                  </a>
                </li>
              </ul>
            </li>

            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/tickets" ? "nav-active" : ""
              }`}
            >
              {" "}
              <Link
                to="/dashboard/tickets"
                onClick={() => handleLinkClick("/dashboard/tickets")}
              >
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.0716 23.8003L17 20.542L11.9283 23.8003L13.4583 17.9637L8.79748 14.167L14.8183 13.7987L17 8.21699L19.1816 13.7987L25.2025 14.167L20.5416 17.9637M28.3333 17.0003C28.3333 16.2489 28.6318 15.5282 29.1632 14.9969C29.6945 14.4655 30.4152 14.167 31.1666 14.167V8.50033C31.1666 7.74888 30.8681 7.02821 30.3368 6.49686C29.8054 5.9655 29.0848 5.66699 28.3333 5.66699H5.66665C4.9152 5.66699 4.19453 5.9655 3.66318 6.49686C3.13182 7.02821 2.83331 7.74888 2.83331 8.50033V14.167C3.58476 14.167 4.30543 14.4655 4.83678 14.9969C5.36814 15.5282 5.66665 16.2489 5.66665 17.0003C5.66665 17.7518 5.36814 18.4724 4.83678 19.0038C4.30543 19.5351 3.58476 19.8337 2.83331 19.8337V25.5003C2.83331 26.2518 3.13182 26.9724 3.66318 27.5038C4.19453 28.0351 4.9152 28.3337 5.66665 28.3337H28.3333C29.0848 28.3337 29.8054 28.0351 30.3368 27.5038C30.8681 26.9724 31.1666 26.2518 31.1666 25.5003V19.8337C30.4152 19.8337 29.6945 19.5351 29.1632 19.0038C28.6318 18.4724 28.3333 17.7518 28.3333 17.0003Z"
                    className="icon-path"
                  />
                </svg>

                <span className="link_name"> Tickets</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Tickets
                  </a>
                </li>
              </ul>
            </li>

            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/job-views" ? "nav-active" : ""
              }`}
            >
              {" "}
              <Link
                to="/dashboard/job-views"
                onClick={() => handleLinkClick("/dashboard/job-views")}
              >
                <svg
                  width="34"
                  height="34"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 512 512"
                >
                  <path
                    className="icon-path"
                    d="M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64l0 48c0 17.7 14.3 32 32 32l1.8 0 11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5l38.7 0c16.3 0 30-12.3 31.8-28.5L318.2 304l1.8 0c17.7 0 32-14.3 32-32l0-48c0-35.3-28.7-64-64-64l-64 0zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
                  />
                </svg>
                <span className="link_name">Job Views</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Job Views
                  </a>
                </li>
              </ul>
            </li>
            <div className="">
              <li className=" dashboard-menu-icon">
                <div
                  className="flex items-center w-full cursor-pointer"
                  onClick={togglesettingSubMenu}
                >
                  <div
                    onClick={togglesettingSubMenu}
                    className="flex items-center"
                  >
                    <svg
                      width="34"
                      height="34"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1964 1.44629H22.6964V4.27962H14.1964V1.44629ZM28.39 10.4974L30.4215 8.46587L28.4183 6.46271L26.3883 8.49279C24.1639 6.71059 21.4059 5.72608 18.5558 5.6968C15.7056 5.66752 12.9281 6.59517 10.6675 8.33129L12.6792 10.3713C14.36 9.17772 16.3694 8.53432 18.4308 8.52962L18.445 8.53104V18.4194L25.4618 25.4432C24.0765 26.8349 22.3094 27.7841 20.3842 28.1706C18.459 28.557 16.4624 28.3633 14.6474 27.614C12.8324 26.8646 11.2807 25.5934 10.1888 23.9614C9.09698 22.3293 8.51415 20.4099 8.51418 18.4463H12.7642L7.09751 12.7796L1.43085 18.4463H5.68085C5.67892 20.4837 6.16527 22.4919 7.09916 24.3026C8.03304 26.1134 9.38727 27.674 11.0484 28.8537C12.7095 30.0333 14.6292 30.7978 16.6465 31.0829C18.6638 31.368 20.7201 31.1655 22.6431 30.4924C24.5661 29.8193 26.2998 28.6952 27.699 27.2142C29.0981 25.7332 30.122 23.9384 30.6848 21.9803C31.2475 20.0222 31.3329 17.9577 30.9336 15.9598C30.5344 13.9619 29.6621 12.0888 28.39 10.4974Z"
                        className="icon-path"
                      />
                    </svg>

                    <span className="link_name">Setting</span>
                  </div>
                  <ul className="sub-menu blank">
                    <li>
                      <p className="link_name" onClick={togglesettingSubMenu}>
                        Setting
                      </p>
                    </li>
                  </ul>
                  {/* {sidebarOpen && <span className=" "> Jobs</span>} */}
                  {sidebarOpen && (
                    <FeatherIcon
                      icon={SettingSubMenuOpen ? "chevron-up" : "chevron-down"}
                      size={16}
                      className="ml-auto text-gray-800"
                    />
                  )}
                </div>
              </li>
              {SettingSubMenuOpen && (
                <ul className=" sub-menu-section ">
                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/account-settings"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/account-settings"
                      onClick={() =>
                        handleLinkClick("/dashboard/account-settings")
                      }
                    >
                      <svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.5416 32.5835C19.9514 32.5835 19.4499 32.3771 19.0371 31.9644C18.6244 31.5517 18.4176 31.0497 18.4166 30.4585V20.5418C18.4166 19.9515 18.6235 19.45 19.0371 19.0373C19.4508 18.6246 19.9523 18.4177 20.5416 18.4168H30.4583C31.0486 18.4168 31.5506 18.6236 31.9642 19.0373C32.3779 19.451 32.5842 19.9525 32.5833 20.5418V30.4585C32.5833 31.0487 32.3769 31.5507 31.9642 31.9644C31.5515 32.378 31.0495 32.5844 30.4583 32.5835H20.5416ZM21.25 30.4585H29.75C29.9389 30.4585 30.1041 30.3876 30.2458 30.246C30.3875 30.1043 30.4583 29.939 30.4583 29.7501C30.4583 29.6085 30.4347 29.4786 30.3875 29.3605C30.3403 29.2425 30.2694 29.1244 30.175 29.0064C29.5847 28.3689 28.8938 27.8612 28.1024 27.4835C27.3109 27.1057 26.4435 26.9168 25.5 26.9168C24.5565 26.9168 23.6885 27.1057 22.8961 27.4835C22.1038 27.8612 21.4134 28.3689 20.825 29.0064C20.7777 29.0536 20.6833 29.3015 20.5416 29.7501C20.5416 29.939 20.6125 30.1043 20.7541 30.246C20.8958 30.3876 21.0611 30.4585 21.25 30.4585ZM25.5 25.5001C26.0902 25.5001 26.5922 25.2933 27.0059 24.8796C27.4196 24.466 27.6259 23.9645 27.625 23.3751C27.624 22.7858 27.4177 22.2843 27.0059 21.8706C26.5941 21.457 26.0921 21.2501 25.5 21.2501C24.9078 21.2501 24.4063 21.457 23.9955 21.8706C23.5846 22.2843 23.3778 22.7858 23.375 23.3751C23.3721 23.9645 23.579 24.4664 23.9955 24.881C24.412 25.2957 24.9135 25.502 25.5 25.5001ZM14.2729 31.1668C13.9187 31.1668 13.6297 31.0662 13.4059 30.865C13.1821 30.6639 13.0461 30.4103 12.9979 30.1043L12.5375 26.7043C12.2305 26.5862 11.9415 26.4446 11.6705 26.2793C11.3994 26.114 11.1336 25.9369 10.8729 25.748L8.67706 26.6689C8.08678 26.9286 7.4965 26.9522 6.90622 26.7397C6.31594 26.5272 5.85553 26.1494 5.52497 25.6064L3.86039 22.7022C3.52983 22.1592 3.43539 21.5807 3.57706 20.9668C3.71872 20.3529 4.03747 19.8453 4.53331 19.4439L6.41039 18.0272C6.38678 17.8619 6.37497 17.7028 6.37497 17.5498V16.5921C6.37497 16.4391 6.38678 16.28 6.41039 16.1147L4.53331 14.698C4.03747 14.2967 3.71872 13.789 3.57706 13.1751C3.43539 12.5612 3.52983 11.9828 3.86039 11.4397L5.52497 8.53555C5.85553 7.99249 6.31594 7.61471 6.90622 7.40221C7.4965 7.18971 8.08678 7.21332 8.67706 7.47305L10.8729 8.39388C11.1326 8.20499 11.4041 8.02791 11.6875 7.86263C11.9708 7.69735 12.2541 7.55569 12.5375 7.43763L12.8562 5.10013C12.9507 4.48624 13.2283 3.9668 13.6892 3.5418C14.1501 3.1168 14.6988 2.9043 15.3354 2.9043H18.6646C19.3021 2.9043 19.8512 3.1168 20.3121 3.5418C20.773 3.9668 21.0502 4.48624 21.1437 5.10013L21.4625 7.43763C21.7694 7.55569 22.0589 7.69735 22.3309 7.86263C22.6029 8.02791 22.8683 8.20499 23.1271 8.39388L25.3229 7.47305C25.9132 7.21332 26.5034 7.18971 27.0937 7.40221C27.684 7.61471 28.1444 7.99249 28.475 8.53555L30.1396 11.4397C30.4701 11.9828 30.5646 12.5612 30.4229 13.1751C30.2812 13.789 29.9625 14.2967 29.4666 14.698L28.5812 15.3355C28.4632 15.43 28.3333 15.4952 28.1916 15.531C28.05 15.5669 27.9083 15.5844 27.7666 15.5835H22.2771C22.1354 15.5835 22.0055 15.5362 21.8875 15.4418C21.7694 15.3474 21.6868 15.2411 21.6396 15.123C21.2618 14.2258 20.6654 13.4882 19.8503 12.9102C19.0352 12.3322 18.1087 12.0427 17.0708 12.0418C15.7014 12.0418 14.5326 12.5258 13.5646 13.4939C12.5965 14.4619 12.1125 15.6307 12.1125 17.0001C12.1125 18.039 12.3901 18.966 12.9455 19.781C13.5008 20.5961 14.2266 21.192 15.1229 21.5689C15.2409 21.6161 15.3472 21.6987 15.4416 21.8168C15.5361 21.9349 15.5833 22.0647 15.5833 22.2064V29.9626C15.5833 30.2932 15.4596 30.5765 15.2121 30.8126C14.9647 31.0487 14.6516 31.1668 14.2729 31.1668Z"
                          className="icon-path"
                        />
                      </svg>

                      <span className="link_name">Profile Settings</span>
                    </Link>
                    <ul className="sub-menu blank">
                      <li>
                        <a
                          className="link_name"
                          href="/dashboard/account-settings"
                        >
                          Profile Setting
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/generate-token"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/generate-token"
                      onClick={() =>
                        handleLinkClick("/dashboard/generate-token")
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        fill="none"
                        viewBox="0 0 576 512"
                      >
                        <path
                          d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
                          className="icon-path"
                        />
                      </svg>
                      <span className="link_name">Authorisation Token</span>
                    </Link>
                    <ul className="sub-menu blank">
                      <li>
                        <a
                          className="link_name"
                          href="/dashboard/generate-token"
                        >
                          Authorisation Token
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/custom-jobsetting"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/custom-jobsetting"
                      onClick={() =>
                        handleLinkClick("/dashboard/custom-jobsetting")
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        fill="none"
                        viewBox="0 0 640 512"
                      >
                        <path
                          d="M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8l-.7 0c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                          className="icon-path"
                        />
                      </svg>
                      <span className="link_name">Custom Job Setting </span>
                    </Link>
                    <ul className="sub-menu blank">
                      <li>
                        <a
                          className="link_name"
                          href="/dashboard/custom-jobsetting"
                        >
                          Custom JobSetting
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/company-setting"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/company-setting"
                      onClick={() =>
                        handleLinkClick("/dashboard/company-setting")
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        fill="none"
                        viewBox="0 0 384 512"
                      >
                        <path
                          d="M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"
                          className="icon-path"
                        />
                      </svg>

                      <span className="link_name">Company Setting</span>
                    </Link>
                    <ul className="sub-menu blank">
                      <li>
                        <a
                          className="link_name"
                          href="/dashboard/company-setting"
                        >
                          Company Setting
                        </a>
                      </li>
                    </ul>
                  </li>

                  {/* <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/crm-setting"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/crm-setting"
                      onClick={() => handleLinkClick("/dashboard/crm-setting")}
                    >
                      <svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.47 19.7463L22.685 17.9799C22.29 17.5924 21.7562 17.375 21.2 17.375H12.695C12.14 17.375 11.6038 17.5939 11.21 17.9799L9.425 19.7463H5V29.2352H7.4C8.06 29.2352 8.5925 28.7082 8.59625 28.0588H8.9375L12.11 30.8939C13.2688 31.8254 14.8775 31.8477 16.07 31.035C16.5388 31.4357 17.045 31.625 17.6113 31.625C18.2938 31.625 18.935 31.3504 19.4413 30.7344C20.27 31.0572 21.2488 30.8309 21.8413 30.1109L22.8238 28.9123C23.0338 28.6562 23.165 28.3631 23.2325 28.0588H25.4037C25.4075 28.7082 25.9438 29.2352 26.6 29.2352H29V19.7463H24.47ZM6.8 28.0477C6.47 28.0477 6.2 27.7805 6.2 27.4539C6.2 27.1273 6.47 26.8602 6.8 26.8602C7.13 26.8602 7.4 27.1273 7.4 27.4539C7.4 27.7842 7.13 28.0477 6.8 28.0477ZM21.425 27.7916L20.4463 28.9865C20.3413 29.1127 20.1538 29.135 20.0225 29.0311L19.1263 28.3111L18.0013 29.6656C17.7763 29.9365 17.4388 29.8438 17.3263 29.7547L15.9463 28.5857L15.3612 29.2982C14.84 29.9328 13.8913 30.0293 13.2875 29.5432L9.63875 26.2775H8.6V21.5238H10.1712L12.485 19.2379C12.56 19.2082 12.6238 19.1822 12.6988 19.1525H14.825L13.3738 20.4699C12.2713 21.4682 12.2075 23.1529 13.2088 24.2291C13.7638 24.8303 15.5038 25.758 17.015 24.3924L17.3225 24.1141L21.38 27.3723C21.5075 27.4762 21.5263 27.6654 21.425 27.7916ZM25.4 26.2775H22.805C22.7188 26.1736 22.6213 26.0771 22.5163 25.9918L18.665 22.8969L19.1338 22.4738C19.3775 22.2512 19.3963 21.8764 19.1713 21.6352L18.7625 21.201C18.5375 20.9598 18.1588 20.9449 17.915 21.1639L15.845 23.0416C15.4888 23.3645 14.8813 23.3904 14.5475 23.0416C14.1988 22.6742 14.2288 22.1102 14.5925 21.7836L17.0525 19.5533C17.33 19.301 17.69 19.1637 18.065 19.1637L21.2038 19.1562C21.2825 19.1562 21.3575 19.1859 21.41 19.2416L23.7238 21.5275H25.4V26.2775ZM27.2 28.0477C26.87 28.0477 26.6 27.7805 26.6 27.4539C26.6 27.1273 26.87 26.8602 27.2 26.8602C27.53 26.8602 27.8 27.1273 27.8 27.4539C27.8 27.7842 27.53 28.0477 27.2 28.0477Z"
                          className="icon-path"
                        />
                        <path
                          d="M25.085 13.4833L27.5329 16.1505L30.2001 13.7026"
                          stroke="#003366"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M15.4375 8.8125C15.4375 8.3981 15.6021 8.00067 15.8951 7.70765C16.1882 7.41462 16.5856 7.25 17 7.25C17.4144 7.25 17.8118 7.41462 18.1049 7.70765C18.3979 8.00067 18.5625 8.3981 18.5625 8.8125C18.5625 9.2269 18.3979 9.62433 18.1049 9.91735C17.8118 10.2104 17.4144 10.375 17 10.375C16.5856 10.375 16.1882 10.2104 15.8951 9.91735C15.6021 9.62433 15.4375 9.2269 15.4375 8.8125ZM18.5625 10.0625C18.5625 9.73098 18.6942 9.41304 18.9286 9.17862C19.163 8.9442 19.481 8.8125 19.8125 8.8125C20.144 8.8125 20.462 8.9442 20.6964 9.17862C20.9308 9.41304 21.0625 9.73098 21.0625 10.0625C21.0625 10.394 20.9308 10.712 20.6964 10.9464C20.462 11.1808 20.144 11.3125 19.8125 11.3125C19.481 11.3125 19.163 11.1808 18.9286 10.9464C18.6942 10.712 18.5625 10.394 18.5625 10.0625ZM12.9375 10.0625C12.9375 9.73098 13.0692 9.41304 13.3036 9.17862C13.538 8.9442 13.856 8.8125 14.1875 8.8125C14.519 8.8125 14.837 8.9442 15.0714 9.17862C15.3058 9.41304 15.4375 9.73098 15.4375 10.0625C15.4375 10.394 15.3058 10.712 15.0714 10.9464C14.837 11.1808 14.519 11.3125 14.1875 11.3125C13.856 11.3125 13.538 11.1808 13.3036 10.9464C13.0692 10.712 12.9375 10.394 12.9375 10.0625ZM14.6292 12.2992C14.8834 11.9009 15.2339 11.5731 15.6482 11.346C16.0626 11.119 16.5275 11 17 11C17.3958 10.9996 17.7871 11.0829 18.1485 11.2442C18.5099 11.4056 18.8331 11.6415 19.097 11.9364C19.3609 12.2313 19.5595 12.5787 19.6799 12.9557C19.8002 13.3327 19.8396 13.7309 19.7954 14.1242C19.79 14.173 19.7732 14.2199 19.7462 14.261C19.7193 14.3022 19.683 14.3364 19.6404 14.3608C18.8369 14.8218 17.9264 15.0638 17 15.0625C16.0736 15.0638 15.1631 14.8218 14.3596 14.3608C14.317 14.3364 14.2807 14.3022 14.2538 14.261C14.2268 14.2199 14.21 14.173 14.2046 14.1242C14.135 13.4853 14.2848 12.8417 14.6292 12.2992Z"
                          fill="#003366"
                        />
                        <path
                          d="M14.1175 11.9392L14.1025 11.9621C13.7022 12.592 13.5164 13.3345 13.5729 14.0788C13.3226 14.0408 13.0764 13.9794 12.8375 13.8954L12.7896 13.8788C12.7467 13.8637 12.7092 13.8365 12.6816 13.8005C12.654 13.7644 12.6375 13.7211 12.6342 13.6758L12.63 13.6254C12.6267 13.5835 12.625 13.5417 12.625 13.5C12.625 13.0977 12.7802 12.711 13.0582 12.4203C13.3362 12.1295 13.7156 11.9572 14.1175 11.9392ZM20.4275 14.0788C20.4845 13.3252 20.2931 12.5737 19.8825 11.9392C20.0921 11.9486 20.2978 12.0001 20.4871 12.0907C20.6763 12.1813 20.8455 12.3091 20.9843 12.4665C21.1231 12.6238 21.2288 12.8076 21.2951 13.0067C21.3614 13.2058 21.3868 13.4162 21.37 13.6254L21.3658 13.6758C21.3624 13.721 21.3459 13.7643 21.3183 13.8002C21.2907 13.8362 21.2532 13.8633 21.2104 13.8783L21.1625 13.895C20.9261 13.9789 20.6811 14.0402 20.4275 14.0788Z"
                          fill="#003366"
                        />
                        <path
                          d="M28.112 13.8449C28.112 8.52535 22.9371 3.14264 16.5536 3.14264C10.1701 3.14264 4.99512 8.52535 4.99512 13.8449"
                          stroke="#003366"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span className="link_name">CRM Setting</span>
                    </Link>
                    <ul className="sub-menu blank">
                      <li>
                        <a className="link_name" href="/dashboard/crm-setting">
                          CRM Setting
                        </a>
                      </li>
                    </ul>
                  </li> */}

                  <li
                    className="dashboard-menu-icon "
                    onClick={DeleteAccountAction}
                  >
                    <a href="javascript:void(0)">
                      <svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_69_18)">
                          <path
                            d="M28.3333 7.08301C28.7091 7.08301 29.0694 7.23226 29.3351 7.49794C29.6007 7.76362 29.75 8.12395 29.75 8.49967C29.75 8.8754 29.6007 9.23573 29.3351 9.50141C29.0694 9.76709 28.7091 9.91634 28.3333 9.91634H26.9167L26.9124 10.0169L25.5907 28.5342C25.5398 29.249 25.2199 29.918 24.6955 30.4064C24.1711 30.8948 23.4811 31.1664 22.7644 31.1663H11.2342C10.5175 31.1664 9.82751 30.8948 9.30309 30.4064C8.77866 29.918 8.4588 29.249 8.40792 28.5342L7.08617 10.0183L7.08333 9.91634H5.66667C5.29094 9.91634 4.93061 9.76709 4.66493 9.50141C4.39926 9.23573 4.25 8.8754 4.25 8.49967C4.25 8.12395 4.39926 7.76362 4.66493 7.49794C4.93061 7.23226 5.29094 7.08301 5.66667 7.08301H28.3333ZM24.0791 9.91634H9.92092L11.2356 28.333H22.7644L24.0791 9.91634ZM19.8333 2.83301C20.2091 2.83301 20.5694 2.98226 20.8351 3.24794C21.1007 3.51362 21.25 3.87395 21.25 4.24967C21.25 4.6254 21.1007 4.98573 20.8351 5.25141C20.5694 5.51709 20.2091 5.66634 19.8333 5.66634H14.1667C13.7909 5.66634 13.4306 5.51709 13.1649 5.25141C12.8993 4.98573 12.75 4.6254 12.75 4.24967C12.75 3.87395 12.8993 3.51362 13.1649 3.24794C13.4306 2.98226 13.7909 2.83301 14.1667 2.83301H19.8333Z"
                            className="icon-path"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_69_18">
                            <rect width="34" height="34" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <span className="link_name"> Delete Account </span>
                    </a>
                    <ul className="sub-menu blank">
                      <li>
                        <a
                          className="link_name"
                          href="/dashboard/delete-account"
                        >
                          Delete Account
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              )}
            </div>
          </ul>
        </div>
      </div>
    </>
  );
};

const SuperAdmin = () => {
  const [activeLink, setActiveLink] = useState("");
  const location = useLocation(); // React Router's hook to get the current location
  const User = getUserData();
  useEffect(() => {
    const pathname = location.pathname;

    // Normalize the pathname
    const normalizedPathname = pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

    // Set the active link based on the current pathname
    setActiveLink(normalizedPathname);
  }, [location.pathname]); // Run this effect when location.pathname changes

  const handleLinkClick = (linkName) => {
    // Normalization is handled in the effect
    const normalizedLinkName = linkName.endsWith("/")
      ? linkName.slice(0, -1)
      : linkName;

    setActiveLink(normalizedLinkName);
  };

  const toggleSubMenu = (e) => {
    let arrowParent = e.currentTarget.parentElement; // Selecting parent element of arrow
    arrowParent.classList.toggle("showMenu");
  };
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  /* ======= For Popup ====== */
  const { openPopup } = usePopup();
  // const [popupComponent, setPopupComponent] = useState(null);

  const handleClosePopup = (message) => {
    //console.log(message);
    //setPopupComponent(null);
    openPopup();
  };

  const DeleteAccountAction = () => {
    const popup = (
      <DeleteAccount onClose={() => handleClosePopup("Popup closed")} />
    );
    //setPopupComponent(popup);
    openPopup(popup);
  };
  /* ======= Ends Popup ====== */
  const [SettingSubMenuOpen, setSettingSubMenuOpen] = useState();
  const togglesettingSubMenu = () => {
    setSettingSubMenuOpen(!SettingSubMenuOpen);
  };
  return (
    <>
      <div className={`sidebar ${sidebarOpen ? "open" : "close"}`}>
        <div className="cross-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-left" color="#fff" size={24} />
        </div>
        <div className="plus-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-right" color="#fff" size={24} />
        </div>
        <div className="main-continor">
          <ul className="nav-links">
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard"
                onClick={() => handleLinkClick("/dashboard")}
              >
                <svg
                  width="34"
                  height="40"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.1225 19.1247H6.63287C5.90555 19.1288 5.20941 19.4206 4.69657 19.9364C4.18373 20.4521 3.89586 21.1499 3.89587 21.8773V27.3668C3.89587 28.0927 4.18424 28.7889 4.69752 29.3022C5.21081 29.8155 5.90698 30.1038 6.63287 30.1038H12.1225C12.8497 30.1039 13.5473 29.8159 14.0628 29.3031C14.5784 28.7902 14.8699 28.094 14.8736 27.3668V21.8773C14.8736 21.1476 14.5838 20.4478 14.0678 19.9319C13.5519 19.4159 12.8521 19.1261 12.1225 19.1261M12.1225 3.89551H6.63287C6.27345 3.89551 5.91754 3.9663 5.58547 4.10385C5.2534 4.2414 4.95168 4.443 4.69752 4.69716C4.44337 4.95131 4.24176 5.25304 4.10422 5.5851C3.96667 5.91717 3.89587 6.27308 3.89587 6.63251V12.1221C3.89586 12.8493 4.18377 13.5469 4.69666 14.0625C5.20954 14.578 5.90568 14.8695 6.63287 14.8733H12.1225C12.8521 14.8733 13.5519 14.5834 14.0678 14.0675C14.5838 13.5515 14.8736 12.8517 14.8736 12.1221V6.63251C14.8699 5.90531 14.5784 5.20917 14.0628 4.69629C13.5473 4.18341 12.8497 3.8955 12.1225 3.89551ZM27.3672 3.89551H21.8776C21.1504 3.8955 20.4528 4.18341 19.9372 4.69629C19.4217 5.20917 19.1302 5.90531 19.1265 6.63251V12.1221C19.1268 12.8516 19.4168 13.5512 19.9327 14.067C20.4485 14.5829 21.1481 14.8729 21.8776 14.8733H27.3672C28.0944 14.8695 28.7905 14.578 29.3034 14.0625C29.8163 13.5469 30.1042 12.8493 30.1042 12.1221V6.63251C30.1042 5.90661 29.8158 5.21044 29.3026 4.69716C28.7893 4.18387 28.0931 3.89551 27.3672 3.89551Z"
                    stroke="#003366"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="path-icon"
                  />
                  <path
                    d="M24.6047 19.5742V29.6552M19.5741 24.6261H29.6551"
                    // stroke="#003366"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    className="path-icon"
                  />
                </svg>
                <span className="link_name">Dashboard</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard">
                    Dashboard
                  </a>
                </li>
              </ul>
            </li>

            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/manage-user" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/manage-user"
                onClick={() => handleLinkClick("/dashboard/manage-user")}
              >
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-label="Manage Users Icon"
                >
                  <path
                    d="M21.25 15.5836V18.4164M24.0836 15.5836H9.91644M22.6664 9.91644H11.3336V5.66644C11.3336 5.29078 11.4828 4.9305 11.7484 4.66487C12.0141 4.39923 12.3743 4.25 12.75 4.25H21.25C21.6257 4.25 21.9859 4.39923 22.2516 4.66487C22.5172 4.9305 22.6664 5.29078 22.6664 5.66644V9.91644Z"
                    stroke="#003366"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M29.75 28.3331V11.3331C29.75 10.9574 29.6008 10.5971 29.3352 10.3313C29.0696 10.0656 28.7093 9.9162 28.3336 9.91602H5.66644C4.88444 9.91602 4.25 10.5505 4.25 11.3331V28.3331C4.25 29.1151 4.88444 29.7496 5.66644 29.7496H28.3336C29.1156 29.7496 29.75 29.1151 29.75 28.3331Z"
                    stroke="#003366"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="link_name">Manage Users</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <Link className="link_name" to="/dashboard/manage-user">
                    Manage Users
                  </Link>
                </li>
              </ul>
            </li>

            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/manage-jobs" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/manage-jobs"
                onClick={() => handleLinkClick("/dashboard/manage-jobs")}
              >
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="#003366"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34 27.625V25.5H31.7677C31.6298 24.8351 31.3658 24.2029 30.9899 23.6374L32.5731 22.0543L31.0707 20.5519L29.4876 22.1351C28.9221 21.7592 28.2899 21.4952 27.625 21.3573V19.125H25.5V21.3573C24.8351 21.4952 24.2029 21.7592 23.6374 22.1351L22.0543 20.5519L20.5519 22.0543L22.1351 23.6374C21.7592 24.2029 21.4952 24.8351 21.3573 25.5H19.125V27.625H21.3573C21.4954 28.3018 21.7653 28.9308 22.1351 29.4876L20.5519 31.0707L22.0543 32.5731L23.6374 30.9899C24.2029 31.3658 24.8351 31.6298 25.5 31.7677V34H27.625V31.7677C28.2899 31.6298 28.9221 31.3658 29.4876 30.9899L31.0707 32.5731L32.5731 31.0707L30.9899 29.4876C31.3658 28.9221 31.6298 28.2899 31.7677 27.625H34ZM26.5625 29.75C24.8051 29.75 23.375 28.3199 23.375 26.5625C23.375 24.8051 24.8051 23.375 26.5625 23.375C28.3199 23.375 29.75 24.8051 29.75 26.5625C29.75 28.3199 28.3199 29.75 26.5625 29.75ZM21.25 18.0625H12.75C12.1864 18.0625 11.6459 17.8386 11.2474 17.4401C10.8489 17.0416 10.625 16.5011 10.625 15.9375V4.25C10.625 3.68641 10.8489 3.14591 11.2474 2.7474C11.6459 2.34888 12.1864 2.125 12.75 2.125H21.25C21.8136 2.125 22.3541 2.34888 22.7526 2.7474C23.1511 3.14591 23.375 3.68641 23.375 4.25V15.9375C23.375 16.5011 23.1511 17.0416 22.7526 17.4401C22.3541 17.8386 21.8136 18.0625 21.25 18.0625ZM12.75 15.9375H21.25V4.25H12.75V15.9375Z"
                    // fill="#003366"
                    className="path-icon"
                  />
                  <path
                    d="M18.0625 22.3125H8.5C7.93641 22.3125 7.39591 22.0886 6.9974 21.6901C6.59888 21.2916 6.375 20.7511 6.375 20.1875V7.4375H8.5V20.1875H18.0625V22.3125Z"
                    // fill="#003366"
                    className="path-icon"
                  />
                  <path
                    d="M13.8125 26.5625H4.25C3.07806 26.5625 2.125 25.6094 2.125 24.4375V11.6875H4.25V24.4375H13.8125V26.5625Z"
                    // fill="#003366"
                    className="path-icon"
                  />
                </svg>

                <span className="link_name"> Manage Jobs</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard/jobs">
                    Manage Jobs
                  </a>
                </li>
              </ul>
            </li>
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/job-applications" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/job-applications"
                onClick={() => handleLinkClick("/dashboard/job-applications")}
              >
                <svg
                  fill="#003366"
                  width="34"
                  height="34"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H176zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z" />
                </svg>
                <span className="link_name"> Manage Applications</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Manage Applications
                  </a>
                </li>
              </ul>
            </li>
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/domains" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/domains"
                onClick={() => handleLinkClick("/dashboard/domains")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#003366"
                  width="34"
                  height="34"
                  viewBox="0 0 512 512"
                >
                  <path
                    className="path-icon"
                    d="M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z"
                  />
                </svg>
                <span className="link_name"> Manage Domains</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard/domains">
                    Manage Domains
                  </a>
                </li>
              </ul>
            </li>

            {/* <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/messages" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/messages"
                onClick={() => handleLinkClick("/dashboard/messages")}
              >
                <svg
                  className="icon"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_69_22)">
                    <path
                      d="M3.92308 5.23047C1.75754 5.23047 0 6.98801 0 9.15355V24.8459C0 27.0114 1.75754 28.7689 3.92308 28.7689H30.0769C32.2425 28.7689 34 27.0114 34 24.8459V9.15355C34 6.98801 32.2425 5.23047 30.0769 5.23047H3.92308ZM3.92308 7.84585H30.0769C30.7975 7.84585 31.3846 8.43301 31.3846 9.15355V9.80739L17 17.5725L2.61538 9.80739V9.15355C2.61538 8.43301 3.20254 7.84585 3.92308 7.84585ZM2.61538 10.1749L11.1559 16.8362L2.77885 25.4186L12.9958 18.1439L17 20.7188L21.0055 18.1439L31.2212 25.4186L22.8441 16.8362L31.3846 10.1749V24.8459C31.3774 25.0472 31.3213 25.2438 31.2212 25.4186C31.0054 25.8436 30.5856 26.1535 30.0769 26.1535H3.92308C3.41438 26.1535 2.99462 25.8449 2.77885 25.4186C2.67892 25.2442 2.62283 25.0468 2.61538 24.8459V10.1749Z"
                      className="icon-path"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_69_22">
                      <rect width="34" height="34" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span className="link_name"> Messages</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Messages
                  </a>
                </li>
              </ul>
            </li> */}
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/tickets" ? "nav-active" : ""
              }`}
            >
              {" "}
              <Link
                to="/dashboard/tickets"
                onClick={() => handleLinkClick("/dashboard/tickets")}
              >
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.0716 23.8003L17 20.542L11.9283 23.8003L13.4583 17.9637L8.79748 14.167L14.8183 13.7987L17 8.21699L19.1816 13.7987L25.2025 14.167L20.5416 17.9637M28.3333 17.0003C28.3333 16.2489 28.6318 15.5282 29.1632 14.9969C29.6945 14.4655 30.4152 14.167 31.1666 14.167V8.50033C31.1666 7.74888 30.8681 7.02821 30.3368 6.49686C29.8054 5.9655 29.0848 5.66699 28.3333 5.66699H5.66665C4.9152 5.66699 4.19453 5.9655 3.66318 6.49686C3.13182 7.02821 2.83331 7.74888 2.83331 8.50033V14.167C3.58476 14.167 4.30543 14.4655 4.83678 14.9969C5.36814 15.5282 5.66665 16.2489 5.66665 17.0003C5.66665 17.7518 5.36814 18.4724 4.83678 19.0038C4.30543 19.5351 3.58476 19.8337 2.83331 19.8337V25.5003C2.83331 26.2518 3.13182 26.9724 3.66318 27.5038C4.19453 28.0351 4.9152 28.3337 5.66665 28.3337H28.3333C29.0848 28.3337 29.8054 28.0351 30.3368 27.5038C30.8681 26.9724 31.1666 26.2518 31.1666 25.5003V19.8337C30.4152 19.8337 29.6945 19.5351 29.1632 19.0038C28.6318 18.4724 28.3333 17.7518 28.3333 17.0003Z"
                    className="icon-path"
                  />
                </svg>

                <span className="link_name"> Tickets</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Tickets
                  </a>
                </li>
              </ul>
            </li>
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/visitors" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/visitors"
                onClick={() => handleLinkClick("/dashboard/visitors")}
              >
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-label="Manage Users Icon"
                >
                  <path
                    d="M21.25 15.5836V18.4164M24.0836 15.5836H9.91644M22.6664 9.91644H11.3336V5.66644C11.3336 5.29078 11.4828 4.9305 11.7484 4.66487C12.0141 4.39923 12.3743 4.25 12.75 4.25H21.25C21.6257 4.25 21.9859 4.39923 22.2516 4.66487C22.5172 4.9305 22.6664 5.29078 22.6664 5.66644V9.91644Z"
                    stroke="#003366"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M29.75 28.3331V11.3331C29.75 10.9574 29.6008 10.5971 29.3352 10.3313C29.0696 10.0656 28.7093 9.9162 28.3336 9.91602H5.66644C4.88444 9.91602 4.25 10.5505 4.25 11.3331V28.3331C4.25 29.1151 4.88444 29.7496 5.66644 29.7496H28.3336C29.1156 29.7496 29.75 29.1151 29.75 28.3331Z"
                    stroke="#003366"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="link_name">Visitors</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <Link className="link_name" to="/dashboard/visitors">
                    Visitors
                  </Link>
                </li>
              </ul>
            </li>

            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/blogs" ? "nav-active" : ""
              }`}
            >
              {" "}
              <Link
                to="/dashboard/blogs"
                onClick={() => handleLinkClick("/dashboard/blogs")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#003366"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <line x1="10" y1="9" x2="9" y2="9"></line>
                </svg>
                <span className="link_name"> Blogs</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="">
                    Blogs
                  </a>
                </li>
              </ul>
            </li>

            <div className="">
              <li className=" dashboard-menu-icon">
                <div
                  className="flex items-center w-full cursor-pointer"
                  onClick={togglesettingSubMenu}
                >
                  <a href="">
                    <svg
                      width="34"
                      height="34"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1964 1.44629H22.6964V4.27962H14.1964V1.44629ZM28.39 10.4974L30.4215 8.46587L28.4183 6.46271L26.3883 8.49279C24.1639 6.71059 21.4059 5.72608 18.5558 5.6968C15.7056 5.66752 12.9281 6.59517 10.6675 8.33129L12.6792 10.3713C14.36 9.17772 16.3694 8.53432 18.4308 8.52962L18.445 8.53104V18.4194L25.4618 25.4432C24.0765 26.8349 22.3094 27.7841 20.3842 28.1706C18.459 28.557 16.4624 28.3633 14.6474 27.614C12.8324 26.8646 11.2807 25.5934 10.1888 23.9614C9.09698 22.3293 8.51415 20.4099 8.51418 18.4463H12.7642L7.09751 12.7796L1.43085 18.4463H5.68085C5.67892 20.4837 6.16527 22.4919 7.09916 24.3026C8.03304 26.1134 9.38727 27.674 11.0484 28.8537C12.7095 30.0333 14.6292 30.7978 16.6465 31.0829C18.6638 31.368 20.7201 31.1655 22.6431 30.4924C24.5661 29.8193 26.2998 28.6952 27.699 27.2142C29.0981 25.7332 30.122 23.9384 30.6848 21.9803C31.2475 20.0222 31.3329 17.9577 30.9336 15.9598C30.5344 13.9619 29.6621 12.0888 28.39 10.4974Z"
                        className="icon-path"
                      />
                    </svg>

                    <span className="link_name">Setting</span>
                  </a>
                  <ul className="sub-menu blank">
                    <li>
                      <a className="link_name" href="/dashboard/jobs">
                        Setting
                      </a>
                    </li>
                  </ul>
                  {/* {sidebarOpen && <span className=" "> Jobs</span>} */}
                  {sidebarOpen && (
                    <FeatherIcon
                      icon={SettingSubMenuOpen ? "chevron-up" : "chevron-down"}
                      size={16}
                      className="ml-auto text-gray-800"
                    />
                  )}
                </div>
              </li>
              {SettingSubMenuOpen && (
                <ul className=" sub-menu-section ">
                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/site-settings"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/site-settings"
                      onClick={() =>
                        handleLinkClick("/dashboard/site-settings")
                      }
                    >
                      <svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.5416 32.5835C19.9514 32.5835 19.4499 32.3771 19.0371 31.9644C18.6244 31.5517 18.4176 31.0497 18.4166 30.4585V20.5418C18.4166 19.9515 18.6235 19.45 19.0371 19.0373C19.4508 18.6246 19.9523 18.4177 20.5416 18.4168H30.4583C31.0486 18.4168 31.5506 18.6236 31.9642 19.0373C32.3779 19.451 32.5842 19.9525 32.5833 20.5418V30.4585C32.5833 31.0487 32.3769 31.5507 31.9642 31.9644C31.5515 32.378 31.0495 32.5844 30.4583 32.5835H20.5416ZM21.25 30.4585H29.75C29.9389 30.4585 30.1041 30.3876 30.2458 30.246C30.3875 30.1043 30.4583 29.939 30.4583 29.7501C30.4583 29.6085 30.4347 29.4786 30.3875 29.3605C30.3403 29.2425 30.2694 29.1244 30.175 29.0064C29.5847 28.3689 28.8938 27.8612 28.1024 27.4835C27.3109 27.1057 26.4435 26.9168 25.5 26.9168C24.5565 26.9168 23.6885 27.1057 22.8961 27.4835C22.1038 27.8612 21.4134 28.3689 20.825 29.0064C20.7777 29.0536 20.6833 29.3015 20.5416 29.7501C20.5416 29.939 20.6125 30.1043 20.7541 30.246C20.8958 30.3876 21.0611 30.4585 21.25 30.4585ZM25.5 25.5001C26.0902 25.5001 26.5922 25.2933 27.0059 24.8796C27.4196 24.466 27.6259 23.9645 27.625 23.3751C27.624 22.7858 27.4177 22.2843 27.0059 21.8706C26.5941 21.457 26.0921 21.2501 25.5 21.2501C24.9078 21.2501 24.4063 21.457 23.9955 21.8706C23.5846 22.2843 23.3778 22.7858 23.375 23.3751C23.3721 23.9645 23.579 24.4664 23.9955 24.881C24.412 25.2957 24.9135 25.502 25.5 25.5001ZM14.2729 31.1668C13.9187 31.1668 13.6297 31.0662 13.4059 30.865C13.1821 30.6639 13.0461 30.4103 12.9979 30.1043L12.5375 26.7043C12.2305 26.5862 11.9415 26.4446 11.6705 26.2793C11.3994 26.114 11.1336 25.9369 10.8729 25.748L8.67706 26.6689C8.08678 26.9286 7.4965 26.9522 6.90622 26.7397C6.31594 26.5272 5.85553 26.1494 5.52497 25.6064L3.86039 22.7022C3.52983 22.1592 3.43539 21.5807 3.57706 20.9668C3.71872 20.3529 4.03747 19.8453 4.53331 19.4439L6.41039 18.0272C6.38678 17.8619 6.37497 17.7028 6.37497 17.5498V16.5921C6.37497 16.4391 6.38678 16.28 6.41039 16.1147L4.53331 14.698C4.03747 14.2967 3.71872 13.789 3.57706 13.1751C3.43539 12.5612 3.52983 11.9828 3.86039 11.4397L5.52497 8.53555C5.85553 7.99249 6.31594 7.61471 6.90622 7.40221C7.4965 7.18971 8.08678 7.21332 8.67706 7.47305L10.8729 8.39388C11.1326 8.20499 11.4041 8.02791 11.6875 7.86263C11.9708 7.69735 12.2541 7.55569 12.5375 7.43763L12.8562 5.10013C12.9507 4.48624 13.2283 3.9668 13.6892 3.5418C14.1501 3.1168 14.6988 2.9043 15.3354 2.9043H18.6646C19.3021 2.9043 19.8512 3.1168 20.3121 3.5418C20.773 3.9668 21.0502 4.48624 21.1437 5.10013L21.4625 7.43763C21.7694 7.55569 22.0589 7.69735 22.3309 7.86263C22.6029 8.02791 22.8683 8.20499 23.1271 8.39388L25.3229 7.47305C25.9132 7.21332 26.5034 7.18971 27.0937 7.40221C27.684 7.61471 28.1444 7.99249 28.475 8.53555L30.1396 11.4397C30.4701 11.9828 30.5646 12.5612 30.4229 13.1751C30.2812 13.789 29.9625 14.2967 29.4666 14.698L28.5812 15.3355C28.4632 15.43 28.3333 15.4952 28.1916 15.531C28.05 15.5669 27.9083 15.5844 27.7666 15.5835H22.2771C22.1354 15.5835 22.0055 15.5362 21.8875 15.4418C21.7694 15.3474 21.6868 15.2411 21.6396 15.123C21.2618 14.2258 20.6654 13.4882 19.8503 12.9102C19.0352 12.3322 18.1087 12.0427 17.0708 12.0418C15.7014 12.0418 14.5326 12.5258 13.5646 13.4939C12.5965 14.4619 12.1125 15.6307 12.1125 17.0001C12.1125 18.039 12.3901 18.966 12.9455 19.781C13.5008 20.5961 14.2266 21.192 15.1229 21.5689C15.2409 21.6161 15.3472 21.6987 15.4416 21.8168C15.5361 21.9349 15.5833 22.0647 15.5833 22.2064V29.9626C15.5833 30.2932 15.4596 30.5765 15.2121 30.8126C14.9647 31.0487 14.6516 31.1668 14.2729 31.1668Z"
                          className="icon-path"
                        />
                      </svg>

                      <span className="link_name">Profile Settings</span>
                    </Link>
                    <ul className="sub-menu blank">
                      <li>
                        <a
                          className="link_name"
                          href="/dashboard/site-settings"
                        >
                          Profile Setting
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/robot" ? "nav-active" : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/robot"
                      onClick={() => handleLinkClick("/dashboard/robot")}
                    >
                      <svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {/* SVG content here */}
                      </svg>

                      <span className="link_name">Robot </span>
                    </Link>
                    <ul className="sub-menu blank">
                      <li>
                        <a className="link_name" href="/dashboard/robot">
                          Robot
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/sitemap" ? "nav-active" : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/sitemap"
                      onClick={() => handleLinkClick("/dashboard/sitemap")}
                    >
                      <svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {/* SVG content here */}
                      </svg>

                      <span className="link_name">Sitemap</span>
                    </Link>
                    <ul className="sub-menu blank">
                      <li>
                        <a className="link_name" href="/dashboard/sitemap">
                          Sitemap
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    className="dashboard-menu-icon "
                    onClick={DeleteAccountAction}
                  >
                    <a href="javascript:void(0)">
                      <svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_69_18)">
                          <path
                            d="M28.3333 7.08301C28.7091 7.08301 29.0694 7.23226 29.3351 7.49794C29.6007 7.76362 29.75 8.12395 29.75 8.49967C29.75 8.8754 29.6007 9.23573 29.3351 9.50141C29.0694 9.76709 28.7091 9.91634 28.3333 9.91634H26.9167L26.9124 10.0169L25.5907 28.5342C25.5398 29.249 25.2199 29.918 24.6955 30.4064C24.1711 30.8948 23.4811 31.1664 22.7644 31.1663H11.2342C10.5175 31.1664 9.82751 30.8948 9.30309 30.4064C8.77866 29.918 8.4588 29.249 8.40792 28.5342L7.08617 10.0183L7.08333 9.91634H5.66667C5.29094 9.91634 4.93061 9.76709 4.66493 9.50141C4.39926 9.23573 4.25 8.8754 4.25 8.49967C4.25 8.12395 4.39926 7.76362 4.66493 7.49794C4.93061 7.23226 5.29094 7.08301 5.66667 7.08301H28.3333ZM24.0791 9.91634H9.92092L11.2356 28.333H22.7644L24.0791 9.91634ZM19.8333 2.83301C20.2091 2.83301 20.5694 2.98226 20.8351 3.24794C21.1007 3.51362 21.25 3.87395 21.25 4.24967C21.25 4.6254 21.1007 4.98573 20.8351 5.25141C20.5694 5.51709 20.2091 5.66634 19.8333 5.66634H14.1667C13.7909 5.66634 13.4306 5.51709 13.1649 5.25141C12.8993 4.98573 12.75 4.6254 12.75 4.24967C12.75 3.87395 12.8993 3.51362 13.1649 3.24794C13.4306 2.98226 13.7909 2.83301 14.1667 2.83301H19.8333Z"
                            className="icon-path"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_69_18">
                            <rect width="34" height="34" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <span className="link_name"> Delete Account </span>
                    </a>
                    <ul className="sub-menu blank">
                      <li>
                        <a
                          className="link_name"
                          href="/dashboard/delete-account"
                        >
                          Delete Account
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              )}
            </div>
          </ul>
        </div>
      </div>
    </>
  );
};

const Candidates = () => {
  const [activeLink, setActiveLink] = useState("");
  const location = useLocation(); // React Router's hook to get the current location
  const [profileSubMenuItems, setProfileSubMenuItems] = useState([]);
  const User = getUserData();
  useEffect(() => {
    const fetchProfileSubMenuData = async () => {
      try {
        const response = await api.getprofileByUserid(User._id); // Replace with your API endpoint
        if (response.status !== 400) {
          setProfileSubMenuItems(response);
        } else {
          // console.error(response);
        }
      } catch (error) {
        console.error("Error fetching profile submenu data:", error);
      }
    };
    fetchProfileSubMenuData();
    const pathname = location.pathname;
    // Normalize the pathname
    const normalizedPathname = pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

    // Set the active link based on the current pathname
    setActiveLink(normalizedPathname);
  }, [location.pathname]); // Run this effect when location.pathname changes

  const handleLinkClick = (linkName) => {
    // Normalization is handled in the effect
    const normalizedLinkName = linkName.endsWith("/")
      ? linkName.slice(0, -1)
      : linkName;

    setActiveLink(normalizedLinkName);
  };

  const toggleSubMenu = (e) => {
    let arrowParent = e.currentTarget.parentElement; // Selecting parent element of arrow
    arrowParent.classList.toggle("showMenu");
  };
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileSubMenuOpen, setProfileSubMenuOpen] = useState(false);
  const [jobsSubMenuOpen, setJobsSubMenuOpen] = useState(false);

  /* ======= For Popup ====== */
  const { openPopup } = usePopup();
  const [isPopupOpen, setIsPopupOpen] = useState([]);
  // const [popupComponent, setPopupComponent] = useState(null);

  const handleClosePopup = (message) => {
    //console.log(message);
    //setPopupComponent(null);
    openPopup();
  };

  const DeleteAccountAction = () => {
    const popup = (
      <DeleteAccount onClose={() => handleClosePopup("Popup closed")} />
    );
    //setPopupComponent(popup);
    openPopup(popup);
  };
  /* ======= Ends Popup ====== */
  const toggleProfileSubMenu = () => {
    setProfileSubMenuOpen(!profileSubMenuOpen);
  };
  const toggleJobeSubMenu = () => {
    setJobsSubMenuOpen(!jobsSubMenuOpen);
    if (profileSubMenuOpen) {
      setProfileSubMenuOpen(false);
      setJobsSubMenuOpen(true);
    }
  };
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const [SettingSubMenuOpen, setSettingSubMenuOpen] = useState();
  const togglesettingSubMenu = () => {
    setSettingSubMenuOpen(!SettingSubMenuOpen);
    // if (profileSubMenuOpen) {
    //   setProfileSubMenuOpen(false);
    //   setJobsSubMenuOpen(true);
    // }
  };
  return (
    <>
      <div className={`sidebar ${sidebarOpen ? "open" : "close"}`}>
        <div className="cross-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-left" color="#fff" size={24} />
        </div>
        <div className="plus-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-right" color="#fff" size={24} />
        </div>
        <div className="main-continor">
          <ul className="nav-links">
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard"
                onClick={() => handleLinkClick("/dashboard")}
              >
                <svg
                  width="34"
                  height="40"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.1225 19.1247H6.63287C5.90555 19.1288 5.20941 19.4206 4.69657 19.9364C4.18373 20.4521 3.89586 21.1499 3.89587 21.8773V27.3668C3.89587 28.0927 4.18424 28.7889 4.69752 29.3022C5.21081 29.8155 5.90698 30.1038 6.63287 30.1038H12.1225C12.8497 30.1039 13.5473 29.8159 14.0628 29.3031C14.5784 28.7902 14.8699 28.094 14.8736 27.3668V21.8773C14.8736 21.1476 14.5838 20.4478 14.0678 19.9319C13.5519 19.4159 12.8521 19.1261 12.1225 19.1261M12.1225 3.89551H6.63287C6.27345 3.89551 5.91754 3.9663 5.58547 4.10385C5.2534 4.2414 4.95168 4.443 4.69752 4.69716C4.44337 4.95131 4.24176 5.25304 4.10422 5.5851C3.96667 5.91717 3.89587 6.27308 3.89587 6.63251V12.1221C3.89586 12.8493 4.18377 13.5469 4.69666 14.0625C5.20954 14.578 5.90568 14.8695 6.63287 14.8733H12.1225C12.8521 14.8733 13.5519 14.5834 14.0678 14.0675C14.5838 13.5515 14.8736 12.8517 14.8736 12.1221V6.63251C14.8699 5.90531 14.5784 5.20917 14.0628 4.69629C13.5473 4.18341 12.8497 3.8955 12.1225 3.89551ZM27.3672 3.89551H21.8776C21.1504 3.8955 20.4528 4.18341 19.9372 4.69629C19.4217 5.20917 19.1302 5.90531 19.1265 6.63251V12.1221C19.1268 12.8516 19.4168 13.5512 19.9327 14.067C20.4485 14.5829 21.1481 14.8729 21.8776 14.8733H27.3672C28.0944 14.8695 28.7905 14.578 29.3034 14.0625C29.8163 13.5469 30.1042 12.8493 30.1042 12.1221V6.63251C30.1042 5.90661 29.8158 5.21044 29.3026 4.69716C28.7893 4.18387 28.0931 3.89551 27.3672 3.89551Z"
                    stroke="#003366"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="path-icon"
                  />
                  <path
                    d="M24.6047 19.5742V29.6552M19.5741 24.6261H29.6551"
                    // stroke="#003366"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    className="path-icon"
                  />
                </svg>
                <span className="link_name">Dashboard</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard">
                    Dashboard
                  </a>
                </li>
              </ul>
            </li>

            <div className="">
              <li
                className={`dashboard-menu-icon  ${
                  activeLink === "/dashboard/profile" ? "nav-active" : ""
                }`}
              >
                <Link
                  to="/dashboard/profile"
                  onClick={() => handleLinkClick("/dashboard/profile")}
                >
                  <div
                    className="flex items-center w-full cursor-pointer "
                    onClick={toggleProfileSubMenu}
                  >
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.25 12.7497H25.5M21.25 16.9997H25.5M21.25 21.2497H25.5M17 22.6663C16.5665 21.7979 15.6782 21.2497 14.7078 21.2497H10.7922C9.82175 21.2497 8.9335 21.7979 8.5 22.6663M5.66667 7.08301H28.3333C28.7091 7.08301 29.0694 7.23226 29.3351 7.49794C29.6007 7.76362 29.75 8.12395 29.75 8.49967V25.4997C29.75 25.8754 29.6007 26.2357 29.3351 26.5014C29.0694 26.7671 28.7091 26.9163 28.3333 26.9163H5.66667C5.29094 26.9163 4.93061 26.7671 4.66493 26.5014C4.39926 26.2357 4.25 25.8754 4.25 25.4997V8.49967C4.25 8.12395 4.39926 7.76362 4.66493 7.49794C4.93061 7.23226 5.29094 7.08301 5.66667 7.08301ZM15.5833 14.1663C15.5833 14.9178 15.2848 15.6385 14.7535 16.1698C14.2221 16.7012 13.5014 16.9997 12.75 16.9997C11.9986 16.9997 11.2779 16.7012 10.7465 16.1698C10.2152 15.6385 9.91667 14.9178 9.91667 14.1663C9.91667 13.4149 10.2152 12.6942 10.7465 12.1629C11.2779 11.6315 11.9986 11.333 12.75 11.333C13.5014 11.333 14.2221 11.6315 14.7535 12.1629C15.2848 12.6942 15.5833 13.4149 15.5833 14.1663Z"
                        stroke="#003366"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="path-icon"
                      />
                    </svg>

                    {sidebarOpen && <span className=" ">Profile</span>}
                    {sidebarOpen && (
                      <FeatherIcon
                        icon={
                          profileSubMenuOpen ? "chevron-up" : "chevron-down"
                        }
                        size={16}
                        className="ml-auto text-gray-800"
                      />
                    )}
                  </div>

                  <ul className="sub-menu blank">
                    <li>
                      <a className="link_name" href="">
                        Profile
                      </a>
                    </li>
                  </ul>
                </Link>
              </li>

              {profileSubMenuOpen && (
                <ul className=" sub-menu-section h-40 overflow-y-scroll overflow-x-hidden custom-scrollbar">
                  {profileSubMenuItems.map((item) => (
                    <li
                      key={item._id}
                      className={`dashboard-menu-icon ${
                        activeLink === "/dashboard/profile/" + item._id
                          ? "nav-active"
                          : ""
                      }`}
                    >
                      <Link
                        to={"/dashboard/profile/" + item._id}
                        onClick={() =>
                          handleLinkClick("/dashboard/profile/" + item._id)
                        }
                      >
                        {sidebarOpen && (
                          <span>
                            {item.jobTitle &&
                            typeof item.jobTitle === "string" &&
                            item.jobTitle.trim() !== ""
                              ? item.jobTitle
                              : "Unnamed"}
                          </span>
                        )}
                      </Link>
                    </li>
                  ))}

                  <li
                    className={`m-auto dashboard-menu-icon ${
                      activeLink === "/dashboard/create-profile"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/create-profile"
                      onClick={() =>
                        handleLinkClick("/dashboard/create-profile")
                      }
                      className="m-auto"
                    >
                      {sidebarOpen && <span>Create Profile</span>}
                    </Link>
                  </li>
                </ul>
              )}
            </div>
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/messages" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/messages"
                onClick={() => handleLinkClick("/dashboard/messages")}
              >
                <div>
                  <svg
                    className="icon"
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_69_22)">
                      <path
                        d="M3.92308 5.23047C1.75754 5.23047 0 6.98801 0 9.15355V24.8459C0 27.0114 1.75754 28.7689 3.92308 28.7689H30.0769C32.2425 28.7689 34 27.0114 34 24.8459V9.15355C34 6.98801 32.2425 5.23047 30.0769 5.23047H3.92308ZM3.92308 7.84585H30.0769C30.7975 7.84585 31.3846 8.43301 31.3846 9.15355V9.80739L17 17.5725L2.61538 9.80739V9.15355C2.61538 8.43301 3.20254 7.84585 3.92308 7.84585ZM2.61538 10.1749L11.1559 16.8362L2.77885 25.4186L12.9958 18.1439L17 20.7188L21.0055 18.1439L31.2212 25.4186L22.8441 16.8362L31.3846 10.1749V24.8459C31.3774 25.0472 31.3213 25.2438 31.2212 25.4186C31.0054 25.8436 30.5856 26.1535 30.0769 26.1535H3.92308C3.41438 26.1535 2.99462 25.8449 2.77885 25.4186C2.67892 25.2442 2.62283 25.0468 2.61538 24.8459V10.1749Z"
                        className="icon-path"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_69_22">
                        <rect width="34" height="34" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <span className="link_name">Messages</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard/messages">
                    Messages
                  </a>
                </li>
              </ul>
            </li>

            <div className="">
              <li className=" dashboard-menu-icon">
                <div
                  className="flex items-center w-full cursor-pointer"
                  onClick={toggleJobeSubMenu}
                >
                  <a href="">
                    <svg
                      width="34"
                      height="34"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1964 1.44629H22.6964V4.27962H14.1964V1.44629ZM28.39 10.4974L30.4215 8.46587L28.4183 6.46271L26.3883 8.49279C24.1639 6.71059 21.4059 5.72608 18.5558 5.6968C15.7056 5.66752 12.9281 6.59517 10.6675 8.33129L12.6792 10.3713C14.36 9.17772 16.3694 8.53432 18.4308 8.52962L18.445 8.53104V18.4194L25.4618 25.4432C24.0765 26.8349 22.3094 27.7841 20.3842 28.1706C18.459 28.557 16.4624 28.3633 14.6474 27.614C12.8324 26.8646 11.2807 25.5934 10.1888 23.9614C9.09698 22.3293 8.51415 20.4099 8.51418 18.4463H12.7642L7.09751 12.7796L1.43085 18.4463H5.68085C5.67892 20.4837 6.16527 22.4919 7.09916 24.3026C8.03304 26.1134 9.38727 27.674 11.0484 28.8537C12.7095 30.0333 14.6292 30.7978 16.6465 31.0829C18.6638 31.368 20.7201 31.1655 22.6431 30.4924C24.5661 29.8193 26.2998 28.6952 27.699 27.2142C29.0981 25.7332 30.122 23.9384 30.6848 21.9803C31.2475 20.0222 31.3329 17.9577 30.9336 15.9598C30.5344 13.9619 29.6621 12.0888 28.39 10.4974Z"
                        className="icon-path"
                      />
                    </svg>

                    <span className="link_name">Jobs</span>
                  </a>
                  <ul className="sub-menu blank">
                    <li>
                      <a className="link_name" href="">
                        Jobs
                      </a>
                    </li>
                  </ul>
                  {/* {sidebarOpen && <span className=" "> Jobs</span>} */}
                  {sidebarOpen && (
                    <FeatherIcon
                      icon={jobsSubMenuOpen ? "chevron-up" : "chevron-down"}
                      size={16}
                      className="ml-auto text-gray-800"
                    />
                  )}
                </div>
              </li>
              {jobsSubMenuOpen && (
                <ul className=" sub-menu-section ">
                  <li
                    className={`dashboard-menu-icon m-auto ${
                      activeLink === "/dashboard/scheduled-interviewed"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/scheduled-interviewed"
                      onClick={() =>
                        handleLinkClick("/dashboard/scheduled-interviewed")
                      }
                      className="m-auto md:pl-10"
                    >
                      {sidebarOpen && (
                        <span className="flex items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            width="28px"
                            height="28px"
                          >
                            <path
                              d="M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                              className="icon-path"
                            />
                          </svg>
                          Scheduled Interviewed
                        </span>
                      )}
                    </Link>
                  </li>

                  <li
                    className={`dashboard-menu-icon m-auto ${
                      activeLink === "/dashboard/jobs-applying"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/jobs-applying"
                      onClick={() =>
                        handleLinkClick("/dashboard/jobs-applying")
                      }
                      className="m-auto md:pl-10"
                    >
                      {sidebarOpen && (
                        <span className="flex items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            width="28px"
                            height="28px"
                          >
                            <path
                              d="M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                              className="icon-path"
                            />
                          </svg>
                          Applying
                        </span>
                      )}
                    </Link>
                  </li>
                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/job-applied"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/job-applied"
                      onClick={() => handleLinkClick("/dashboard/job-applied")}
                    >
                      {sidebarOpen && (
                        <span className="flex items-center">
                          {" "}
                          <svg
                            width="28px"
                            height="28px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5Z"
                              stroke="#003366"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M9 12L11 14L15 10"
                              stroke="#003366"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M9 16H15"
                              stroke="#003366"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          Applied
                        </span>
                      )}
                    </Link>
                  </li>
                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/job-saved" ? "nav-active" : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/job-saved"
                      onClick={() => handleLinkClick("/dashboard/job-saved")}
                    >
                      {sidebarOpen && (
                        <span className="flex items-center">
                          <svg
                            width="28px"
                            height="28px"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 384 512"
                          >
                            <path
                              className="icon-path"
                              d="M0 48C0 21.5 21.5 0 48 0l0 48 0 393.4 130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4 336 48 48 48 48 0 336 0c26.5 0 48 21.5 48 48l0 440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488L0 48z"
                            />
                          </svg>
                          Saved
                        </span>
                      )}
                    </Link>
                  </li>
                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/job-interviewed"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/job-interviewed"
                      onClick={() =>
                        handleLinkClick("/dashboard/job-interviewed")
                      }
                    >
                      {sidebarOpen && (
                        <span className="flex items-center">
                          <svg
                            width="28px"
                            height="28px"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                          >
                            <path
                              className="icon-path"
                              d="M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z"
                            />
                          </svg>
                          Interviewed
                        </span>
                      )}
                    </Link>
                  </li>
                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/job-alerts" ? "nav-active" : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/job-alerts"
                      onClick={() => handleLinkClick("/dashboard/job-alerts")}
                    >
                      {sidebarOpen && (
                        <span className="flex items-center">
                          <svg
                            width="28px"
                            height="28px"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 512"
                          >
                            <path
                              className="icon-path"
                              d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 17.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96l8 0 8 0c57.4 0 104 46.6 104 104l0 33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48-176.9 0c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1l0 11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l286.2 0zM384 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
                            />
                          </svg>
                          Alert Matching
                        </span>
                      )}
                    </Link>
                  </li>
                </ul>
              )}
            </div>

            <div className="">
              <li className=" dashboard-menu-icon">
                <div
                  className="flex items-center w-full cursor-pointer"
                  onClick={togglesettingSubMenu}
                >
                  <a href="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width="34"
                      height="34"
                      fill="#003366"
                    >
                      <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
                    </svg>
                    {/* <svg
                      width="34"
                      height="34"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1964 1.44629H22.6964V4.27962H14.1964V1.44629ZM28.39 10.4974L30.4215 8.46587L28.4183 6.46271L26.3883 8.49279C24.1639 6.71059 21.4059 5.72608 18.5558 5.6968C15.7056 5.66752 12.9281 6.59517 10.6675 8.33129L12.6792 10.3713C14.36 9.17772 16.3694 8.53432 18.4308 8.52962L18.445 8.53104V18.4194L25.4618 25.4432C24.0765 26.8349 22.3094 27.7841 20.3842 28.1706C18.459 28.557 16.4624 28.3633 14.6474 27.614C12.8324 26.8646 11.2807 25.5934 10.1888 23.9614C9.09698 22.3293 8.51415 20.4099 8.51418 18.4463H12.7642L7.09751 12.7796L1.43085 18.4463H5.68085C5.67892 20.4837 6.16527 22.4919 7.09916 24.3026C8.03304 26.1134 9.38727 27.674 11.0484 28.8537C12.7095 30.0333 14.6292 30.7978 16.6465 31.0829C18.6638 31.368 20.7201 31.1655 22.6431 30.4924C24.5661 29.8193 26.2998 28.6952 27.699 27.2142C29.0981 25.7332 30.122 23.9384 30.6848 21.9803C31.2475 20.0222 31.3329 17.9577 30.9336 15.9598C30.5344 13.9619 29.6621 12.0888 28.39 10.4974Z"
                        className="icon-path"
                      />
                    </svg> */}

                    <span className="link_name">Setting</span>
                  </a>
                  <ul className="sub-menu blank">
                    <li>
                      <a className="link_name" href="/dashboard/jobs">
                        Setting
                      </a>
                    </li>
                  </ul>
                  {/* {sidebarOpen && <span className=" "> Jobs</span>} */}
                  {sidebarOpen && (
                    <FeatherIcon
                      icon={SettingSubMenuOpen ? "chevron-up" : "chevron-down"}
                      size={16}
                      className="ml-auto text-gray-800"
                    />
                  )}
                </div>
              </li>
              {SettingSubMenuOpen && (
                <ul className=" sub-menu-section ">
                  <li
                    className={`dashboard-menu-icon ${
                      activeLink === "/dashboard/site-settings"
                        ? "nav-active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/dashboard/site-settings"
                      onClick={() =>
                        handleLinkClick("/dashboard/site-settings")
                      }
                    >
                      <svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.5416 32.5835C19.9514 32.5835 19.4499 32.3771 19.0371 31.9644C18.6244 31.5517 18.4176 31.0497 18.4166 30.4585V20.5418C18.4166 19.9515 18.6235 19.45 19.0371 19.0373C19.4508 18.6246 19.9523 18.4177 20.5416 18.4168H30.4583C31.0486 18.4168 31.5506 18.6236 31.9642 19.0373C32.3779 19.451 32.5842 19.9525 32.5833 20.5418V30.4585C32.5833 31.0487 32.3769 31.5507 31.9642 31.9644C31.5515 32.378 31.0495 32.5844 30.4583 32.5835H20.5416ZM21.25 30.4585H29.75C29.9389 30.4585 30.1041 30.3876 30.2458 30.246C30.3875 30.1043 30.4583 29.939 30.4583 29.7501C30.4583 29.6085 30.4347 29.4786 30.3875 29.3605C30.3403 29.2425 30.2694 29.1244 30.175 29.0064C29.5847 28.3689 28.8938 27.8612 28.1024 27.4835C27.3109 27.1057 26.4435 26.9168 25.5 26.9168C24.5565 26.9168 23.6885 27.1057 22.8961 27.4835C22.1038 27.8612 21.4134 28.3689 20.825 29.0064C20.7777 29.0536 20.6833 29.3015 20.5416 29.7501C20.5416 29.939 20.6125 30.1043 20.7541 30.246C20.8958 30.3876 21.0611 30.4585 21.25 30.4585ZM25.5 25.5001C26.0902 25.5001 26.5922 25.2933 27.0059 24.8796C27.4196 24.466 27.6259 23.9645 27.625 23.3751C27.624 22.7858 27.4177 22.2843 27.0059 21.8706C26.5941 21.457 26.0921 21.2501 25.5 21.2501C24.9078 21.2501 24.4063 21.457 23.9955 21.8706C23.5846 22.2843 23.3778 22.7858 23.375 23.3751C23.3721 23.9645 23.579 24.4664 23.9955 24.881C24.412 25.2957 24.9135 25.502 25.5 25.5001ZM14.2729 31.1668C13.9187 31.1668 13.6297 31.0662 13.4059 30.865C13.1821 30.6639 13.0461 30.4103 12.9979 30.1043L12.5375 26.7043C12.2305 26.5862 11.9415 26.4446 11.6705 26.2793C11.3994 26.114 11.1336 25.9369 10.8729 25.748L8.67706 26.6689C8.08678 26.9286 7.4965 26.9522 6.90622 26.7397C6.31594 26.5272 5.85553 26.1494 5.52497 25.6064L3.86039 22.7022C3.52983 22.1592 3.43539 21.5807 3.57706 20.9668C3.71872 20.3529 4.03747 19.8453 4.53331 19.4439L6.41039 18.0272C6.38678 17.8619 6.37497 17.7028 6.37497 17.5498V16.5921C6.37497 16.4391 6.38678 16.28 6.41039 16.1147L4.53331 14.698C4.03747 14.2967 3.71872 13.789 3.57706 13.1751C3.43539 12.5612 3.52983 11.9828 3.86039 11.4397L5.52497 8.53555C5.85553 7.99249 6.31594 7.61471 6.90622 7.40221C7.4965 7.18971 8.08678 7.21332 8.67706 7.47305L10.8729 8.39388C11.1326 8.20499 11.4041 8.02791 11.6875 7.86263C11.9708 7.69735 12.2541 7.55569 12.5375 7.43763L12.8562 5.10013C12.9507 4.48624 13.2283 3.9668 13.6892 3.5418C14.1501 3.1168 14.6988 2.9043 15.3354 2.9043H18.6646C19.3021 2.9043 19.8512 3.1168 20.3121 3.5418C20.773 3.9668 21.0502 4.48624 21.1437 5.10013L21.4625 7.43763C21.7694 7.55569 22.0589 7.69735 22.3309 7.86263C22.6029 8.02791 22.8683 8.20499 23.1271 8.39388L25.3229 7.47305C25.9132 7.21332 26.5034 7.18971 27.0937 7.40221C27.684 7.61471 28.1444 7.99249 28.475 8.53555L30.1396 11.4397C30.4701 11.9828 30.5646 12.5612 30.4229 13.1751C30.2812 13.789 29.9625 14.2967 29.4666 14.698L28.5812 15.3355C28.4632 15.43 28.3333 15.4952 28.1916 15.531C28.05 15.5669 27.9083 15.5844 27.7666 15.5835H22.2771C22.1354 15.5835 22.0055 15.5362 21.8875 15.4418C21.7694 15.3474 21.6868 15.2411 21.6396 15.123C21.2618 14.2258 20.6654 13.4882 19.8503 12.9102C19.0352 12.3322 18.1087 12.0427 17.0708 12.0418C15.7014 12.0418 14.5326 12.5258 13.5646 13.4939C12.5965 14.4619 12.1125 15.6307 12.1125 17.0001C12.1125 18.039 12.3901 18.966 12.9455 19.781C13.5008 20.5961 14.2266 21.192 15.1229 21.5689C15.2409 21.6161 15.3472 21.6987 15.4416 21.8168C15.5361 21.9349 15.5833 22.0647 15.5833 22.2064V29.9626C15.5833 30.2932 15.4596 30.5765 15.2121 30.8126C14.9647 31.0487 14.6516 31.1668 14.2729 31.1668Z"
                          className="icon-path"
                        />
                      </svg>

                      <span className="link_name">Account Settings</span>
                    </Link>
                    <ul className="sub-menu blank">
                      <li>
                        <a
                          className="link_name"
                          href="/dashboard/site-settings"
                        >
                          Account Settings
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    className="dashboard-menu-icon "
                    onClick={DeleteAccountAction}
                  >
                    <a href="javascript:void(0)">
                      <svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_69_18)">
                          <path
                            d="M28.3333 7.08301C28.7091 7.08301 29.0694 7.23226 29.3351 7.49794C29.6007 7.76362 29.75 8.12395 29.75 8.49967C29.75 8.8754 29.6007 9.23573 29.3351 9.50141C29.0694 9.76709 28.7091 9.91634 28.3333 9.91634H26.9167L26.9124 10.0169L25.5907 28.5342C25.5398 29.249 25.2199 29.918 24.6955 30.4064C24.1711 30.8948 23.4811 31.1664 22.7644 31.1663H11.2342C10.5175 31.1664 9.82751 30.8948 9.30309 30.4064C8.77866 29.918 8.4588 29.249 8.40792 28.5342L7.08617 10.0183L7.08333 9.91634H5.66667C5.29094 9.91634 4.93061 9.76709 4.66493 9.50141C4.39926 9.23573 4.25 8.8754 4.25 8.49967C4.25 8.12395 4.39926 7.76362 4.66493 7.49794C4.93061 7.23226 5.29094 7.08301 5.66667 7.08301H28.3333ZM24.0791 9.91634H9.92092L11.2356 28.333H22.7644L24.0791 9.91634ZM19.8333 2.83301C20.2091 2.83301 20.5694 2.98226 20.8351 3.24794C21.1007 3.51362 21.25 3.87395 21.25 4.24967C21.25 4.6254 21.1007 4.98573 20.8351 5.25141C20.5694 5.51709 20.2091 5.66634 19.8333 5.66634H14.1667C13.7909 5.66634 13.4306 5.51709 13.1649 5.25141C12.8993 4.98573 12.75 4.6254 12.75 4.24967C12.75 3.87395 12.8993 3.51362 13.1649 3.24794C13.4306 2.98226 13.7909 2.83301 14.1667 2.83301H19.8333Z"
                            className="icon-path"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_69_18">
                            <rect width="34" height="34" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <span className="link_name"> Delete Account </span>
                    </a>
                    <ul className="sub-menu blank">
                      <li>
                        <a
                          className="link_name"
                          href="/dashboard/delete-account"
                        >
                          Delete Account
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              )}
            </div>
          </ul>
        </div>
      </div>
    </>
  );
};

const Seller = () => {
  const [activeLink, setActiveLink] = useState("");
  const location = useLocation(); // React Router's hook to get the current location

  useEffect(() => {
    const pathname = location.pathname;

    // Normalize the pathname
    const normalizedPathname = pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

    // Set the active link based on the current pathname
    setActiveLink(normalizedPathname);
  }, [location.pathname]); // Run this effect when location.pathname changes

  const handleLinkClick = (linkName) => {
    // Normalization is handled in the effect
    const normalizedLinkName = linkName.endsWith("/")
      ? linkName.slice(0, -1)
      : linkName;

    setActiveLink(normalizedLinkName);
  };

  const toggleSubMenu = (e) => {
    let arrowParent = e.currentTarget.parentElement; // Selecting parent element of arrow
    arrowParent.classList.toggle("showMenu");
  };
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileSubMenuOpen, setProfileSubMenuOpen] = useState(false);
  const [jobsSubMenuOpen, setJobsSubMenuOpen] = useState(false);

  /* ======= For Popup ====== */
  const { openPopup } = usePopup();
  const [isPopupOpen, setIsPopupOpen] = useState([]);
  // const [popupComponent, setPopupComponent] = useState(null);

  const handleClosePopup = (message) => {
    //console.log(message);
    //setPopupComponent(null);
    openPopup();
  };

  const DeleteAccountAction = () => {
    const popup = (
      <DeleteAccount onClose={() => handleClosePopup("Popup closed")} />
    );
    //setPopupComponent(popup);
    openPopup(popup);
  };
  /* ======= Ends Popup ====== */
  const toggleProfileSubMenu = () => {
    setProfileSubMenuOpen(!profileSubMenuOpen);
  };
  const toggleJobeSubMenu = () => {
    setJobsSubMenuOpen(!jobsSubMenuOpen);
    if (profileSubMenuOpen) {
      setProfileSubMenuOpen(false);
      setJobsSubMenuOpen(true);
    }
  };
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const currentPath = location.pathname;

  const isActiveLink = (path) => {
    // Check if current path matches the given path or is a subpath
    return (
      currentPath === path || currentPath.startsWith(`${path}/`) // For dynamic paths like /dashboard/courses/:id
    );
  };
  return (
    <>
      <div className={`sidebar sellermanu ${sidebarOpen ? "open" : "close"}`}>
        <div className="cross-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-left" color="#fff" size={24} />
        </div>
        <div className="plus-icon-btn" onClick={toggleSidebar}>
          <FeatherIcon icon="chevron-right" color="#fff" size={24} />
        </div>
        <div className="main-continor">
          <ul className="nav-links">
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard"
                onClick={() => handleLinkClick("/dashboard")}
              >
                <svg
                  width="34"
                  height="40"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.1225 19.1247H6.63287C5.90555 19.1288 5.20941 19.4206 4.69657 19.9364C4.18373 20.4521 3.89586 21.1499 3.89587 21.8773V27.3668C3.89587 28.0927 4.18424 28.7889 4.69752 29.3022C5.21081 29.8155 5.90698 30.1038 6.63287 30.1038H12.1225C12.8497 30.1039 13.5473 29.8159 14.0628 29.3031C14.5784 28.7902 14.8699 28.094 14.8736 27.3668V21.8773C14.8736 21.1476 14.5838 20.4478 14.0678 19.9319C13.5519 19.4159 12.8521 19.1261 12.1225 19.1261M12.1225 3.89551H6.63287C6.27345 3.89551 5.91754 3.9663 5.58547 4.10385C5.2534 4.2414 4.95168 4.443 4.69752 4.69716C4.44337 4.95131 4.24176 5.25304 4.10422 5.5851C3.96667 5.91717 3.89587 6.27308 3.89587 6.63251V12.1221C3.89586 12.8493 4.18377 13.5469 4.69666 14.0625C5.20954 14.578 5.90568 14.8695 6.63287 14.8733H12.1225C12.8521 14.8733 13.5519 14.5834 14.0678 14.0675C14.5838 13.5515 14.8736 12.8517 14.8736 12.1221V6.63251C14.8699 5.90531 14.5784 5.20917 14.0628 4.69629C13.5473 4.18341 12.8497 3.8955 12.1225 3.89551ZM27.3672 3.89551H21.8776C21.1504 3.8955 20.4528 4.18341 19.9372 4.69629C19.4217 5.20917 19.1302 5.90531 19.1265 6.63251V12.1221C19.1268 12.8516 19.4168 13.5512 19.9327 14.067C20.4485 14.5829 21.1481 14.8729 21.8776 14.8733H27.3672C28.0944 14.8695 28.7905 14.578 29.3034 14.0625C29.8163 13.5469 30.1042 12.8493 30.1042 12.1221V6.63251C30.1042 5.90661 29.8158 5.21044 29.3026 4.69716C28.7893 4.18387 28.0931 3.89551 27.3672 3.89551Z"
                    stroke="#003366"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="path-icon"
                  />
                  <path
                    d="M24.6047 19.5742V29.6552M19.5741 24.6261H29.6551"
                    // stroke="#003366"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    className="path-icon"
                  />
                </svg>
                <span className="link_name">Dashboard</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard">
                    Dashboard
                  </a>
                </li>
              </ul>
            </li>

            <li
              className={`dashboard-menu-icon course-icon  ${
                isActiveLink("/dashboard/courses") ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/courses"
                onClick={() => handleLinkClick("/dashboard/courses")}
              >
                <div className="course-icon">
                  <FeatherIcon
                    icon="bookmark"
                    size={34}
                    style={{ fill: "#003366" }} // Default color
                    className="ml-auto hover:fill-[#ffa500]" // Hover color
                  />
                </div>
                <span className="link_name">Courses</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard/courses">
                    Courses
                  </a>
                </li>
              </ul>
            </li>

            <li
              className={`dashboard-menu-icon course-icon ${
                isActiveLink("/dashboard/enrollment-enquiries")
                  ? "nav-active"
                  : ""
              }`}
            >
              <Link
                to="/dashboard/enrollment-enquiries"
                onClick={() =>
                  handleLinkClick("/dashboard/enrollment-enquiries")
                }
              >
                <div className="course-icon">
                  <FeatherIcon
                    icon="bookmark"
                    size={34}
                    style={{ fill: "#003366" }} // Default color
                    className="ml-auto hover:fill-[#ffa500]" // Hover color
                  />
                </div>
                <span className="link_name">Enrollment Enquiries</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a
                    className="link_name"
                    href="/dashboard/enrollment-enquiries"
                  >
                    Enrollment Enquiries
                  </a>
                </li>
              </ul>
            </li>
            <li
              className={`dashboard-menu-icon ${
                activeLink === "/dashboard/messages" ? "nav-active" : ""
              }`}
            >
              <Link
                to="/dashboard/messages"
                onClick={() => handleLinkClick("/dashboard/messages")}
              >
                <div>
                  <svg
                    className="icon"
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_69_22)">
                      <path
                        d="M3.92308 5.23047C1.75754 5.23047 0 6.98801 0 9.15355V24.8459C0 27.0114 1.75754 28.7689 3.92308 28.7689H30.0769C32.2425 28.7689 34 27.0114 34 24.8459V9.15355C34 6.98801 32.2425 5.23047 30.0769 5.23047H3.92308ZM3.92308 7.84585H30.0769C30.7975 7.84585 31.3846 8.43301 31.3846 9.15355V9.80739L17 17.5725L2.61538 9.80739V9.15355C2.61538 8.43301 3.20254 7.84585 3.92308 7.84585ZM2.61538 10.1749L11.1559 16.8362L2.77885 25.4186L12.9958 18.1439L17 20.7188L21.0055 18.1439L31.2212 25.4186L22.8441 16.8362L31.3846 10.1749V24.8459C31.3774 25.0472 31.3213 25.2438 31.2212 25.4186C31.0054 25.8436 30.5856 26.1535 30.0769 26.1535H3.92308C3.41438 26.1535 2.99462 25.8449 2.77885 25.4186C2.67892 25.2442 2.62283 25.0468 2.61538 24.8459V10.1749Z"
                        className="icon-path"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_69_22">
                        <rect width="34" height="34" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <span className="link_name">Messages</span>
              </Link>
              <ul className="sub-menu blank">
                <li>
                  <a className="link_name" href="/dashboard/messages">
                    Messages
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export { SuperAdmin, Menubar, Employers, Candidates, Seller };
